module.exports = __webpack_public_path__ + "img/more-button.ce1eb7fc.svg";